<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-text-field v-model="suche" append-icon="mdi-table-search" label="Suche" single-line hide-details />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="offerList"
      :search="suche"
      :item-class="offerBackground"
      :items-per-page="50"
      sort-by="compare_date"
      sort-asc
      :footer-props="{
        itemsPerPageOptions: [-1, 50, 100],
      }"
    >
      <template #[`item.id`]="{ item }">
        <inertia-link
          :href="route('offer.show', { offer: item.id })"
        >
          {{ item.id }}
        </inertia-link>
      </template>
      <template #[`item.company_name`]="{ item }">
        <inertia-link
          :href="route('customer.show.uebersicht', { customer: item.company_id })"
        >
          {{ item.company_name }}
        </inertia-link>
      </template>
      <template #[`item.turnover`]="{ item }">
        {{ item.turnover ? moneyFormatter.format(item.turnover) : "-" }}
      </template>
      <template #[`item.turnover_one_time`]="{ item }">
        {{ item.turnover_one_time ? moneyFormatter.format(item.turnover_one_time) : "-" }}
      </template>
      <template #[`item.monthly_turnover`]="{ item }">
        {{ item.monthly_turnover ? moneyFormatter.format(item.monthly_turnover) : "-" }}
      </template>
      <template #[`item.compare_date`]="{ item }">
        {{ getDateString(item.compare_date) }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import {
   formattedDateTimeString
} from '@/plugins/formatDate.js'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Todo',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      offerList: {
         type: Array,
         required: true,
      },
   },

   data () {
      return {
         loading: false,
         suche: '',
         performer: null,
         moneyFormatter: new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
         }),
      }
   },
   computed: {
      headers () {
         return [
            {
               text: 'Angebot #',
               value: 'id',
               sortable: true,
               filterable: true,
            },
            {
               text: 'Status',
               value: 'cur_status',
               sortable: true,
               filterable: true,
            },
            {
               text: 'KDNR.',
               value: 'company_number',
               sortable: true,
               filterable: true,
            },
            {
               text: 'Firma',
               value: 'company_name',
               sortable: true,
               filterable: true,
            },
            {
               text: 'VB.',
               value: 'performer_full_name',
               sortable: true,
               filterable: true,
            },
            {
               text: 'Umsatz Ges.',
               value: 'turnover',
               sortable: true,
               filterable: false,
            },
            {
               text: 'Umsatz Einm.',
               value: 'turnover_one_time',
               sortable: true,
               filterable: false,
            },
            {
               text: 'Umsatz Mtl.',
               value: 'monthly_turnover',
               sortable: true,
               filterable: false,
            },
            {
               text: 'Laufzeit in M',
               value: 'months',
               sortable: true,
               filterable: false,
            },
            {
               text: 'Angebotsdatum',
               value: 'compare_date',
               sortable: true,
               filterable: false,
            },
            //  {
            //     text: 'Aktionen',
            //     value: 'actions',
            //     sortable: false,
            //     filterable: false,
            //     width: '20%',
            //  },
         ]
      }

   },
   methods: {
      offerBackground (offer) {
         if (offer.time_diff > 60) {
            return 'red lighten-4'
         } else if (offer.time_diff > 14) {
            return 'orange lighten-4'
         }
      },
      getDateString (dateVal) {
         return formattedDateTimeString(dateVal)
      }
   },
}
</script>
